
import "./OutPut.css"
import { PiTerminal } from "react-icons/pi";
function Output({codeOutput,language, handleRunCode}) {



  return (
    <div className="relative h-full  flex flex-col">
      <div className="btn-warp right-0 flex justify-between items-center bg-gray-700   border p-1 border-gray-300 border-b-0  rounded-tr rounded-tl">
        <PiTerminal className="p-1 text-3xl bg-gray-800 rounded"/> 
        <button
          className="  hover:bg-gray-600 text-white py-2 px-4 rounded bg-gray-800"
          onClick={handleRunCode}
        >
          Run Code
        </button>
      </div>
      
      <div className="outputcontainer min-h-[50vh] flex-grow overflow-auto bg-gray-700 p-4 border  ">
        {/* Render output based on language */}
        {language === 'html'? (
          <div dangerouslySetInnerHTML={{ __html: codeOutput }}></div>
        ) : (
          <pre>{codeOutput}</pre>
        )}
      </div>
    </div>
  );
}

export default Output;